import { current, produce } from 'immer'

import {
  extract_author,
  extract_end,
  extract_log,
  extract_message,
  extract_next_steps,
  extract_prompts,
} from './stream.handler'

import { MessageType } from '../../../common/ai.dictionary'
import { AiState } from '../../ai.state'

export const onGetAnswerEventStream = (state: AiState, { response }: { response: any }): AiState =>
  produce(state, (draft: AiState) => {
    if (!current(draft).backgroundAiResponse) {
      draft.streamingAiResponse = true
      draft.pendingAiResponse = true
    }
    const { message, context, sources } = response
    const lastMessageDraft = draft.messages[draft.messages.length - 1]
    const answer = extract_message(message)
    const nextSteps = extract_next_steps(message)
    const end = extract_end(message)
    const log = extract_log(message)
    const prompts = extract_prompts(message)
    const author = extract_author(message)

    if (message.answer?.operation === 'session') {
      draft.sessionId = message.answer.thread_id
      if (message.answer.request_id) {
        draft.lastRequestId = message.answer.request_id
      }
    }
    // parse logs and register
    if (log) {
      draft.logs.unshift({
        agent: log.agent,
        message: log.debug.info,
        message_type: 'INFO',
        timestamp: log.timestamp,
        status: log.debug.status,
        step: log.debug.step,
      })
      draft.currentAITaskMessage = log.debug.info
      return
    }
    if ((message as any).answer) {
      parseAnswerMessage(draft, message)
    }
    if (end) {
      parseEndMessage(draft, message)
      return
    }
    if (!answer && !nextSteps) {
      return
    }
    const isLastMessageOfTypeAi =
      lastMessageDraft &&
      lastMessageDraft?.type === MessageType.AiMsg &&
      !lastMessageDraft?.commited
    if (isLastMessageOfTypeAi) {
      Object.assign(lastMessageDraft, response)
      lastMessageDraft.message = nextSteps + answer
      lastMessageDraft.context = null
      lastMessageDraft.sources = sources
      lastMessageDraft.author = author
      lastMessageDraft.html_preview = null
      lastMessageDraft.prompts = prompts
      lastMessageDraft.type = MessageType.AiMsg
    } else {
      draft.messages.push({
        ...response,
        message,
        context,
        sources,
        type: MessageType.AiMsg,
      })
    }
  })

function parseAnswerMessage(draft: AiState, messagePayload): void {
  const payload_code = messagePayload.end
    ? { data_model: messagePayload.end.answer }
    : messagePayload.answer
  generateDataModel(draft, payload_code)
}

function generateDataModel(draft: AiState, messagePayload): void {
  if (messagePayload && messagePayload.data_model && messagePayload.render) {
    draft.generatedDataModel = {
      entities: messagePayload.data_model?.entities,
      root: messagePayload.data_model?.root,
    }
  }
}

function parseEndMessage(draft: AiState, message): void {
  const messagePayload = message.end

  if (messagePayload.operation === 'check_greeting') {
    draft.reasoningLogs.unshift({
      agent: message.agent,
      message: message.end.answer.reasoning,
      message_type: 'REASONING',
      operation: 'CHECK USER PROMPT',
    })
  }

  if (messagePayload.operation === 'generate_data_model') {
    generateDataModel(draft, { data_model: { ...messagePayload.answer }, render: true })
    draft.reasoningLogs.unshift({
      agent: message.agent,
      message: message.end.answer.reasoning,
      message_type: 'REASONING',
      operation: 'DATA MODEL GENERATION',
    })
    draft.messages.push({
      message: messagePayload.answer.description,
      type: MessageType.AiMsg,
      commited: true,
    })
    draft.pendingRouteToArchitect = null
    draft.streamingAiResponse = false
    draft.pendingAiResponse = false
    draft.backgroundAiResponse = true
    draft.isAiInteractionAllowed = false
    draft.currentAITaskMessage = null
  }
  if (messagePayload.operation === 'initial_actions') {
    draft.messages[draft.messages.length - 1].commited = true
  }
}
